<template>
  <Legal />
</template>

<script setup>
import Legal from '@/sections/legal/Legal.vue';
</script>
